<template>
  <div class="item-container">
    <a-carousel arrows :dots="false">
      <template #prevArrow>
        <div class="custom-slick-arrow" style="left: 0; z-index: 1;">
          <LeftOutlined />
        </div>
      </template>
      <template #nextArrow>
        <div class="custom-slick-arrow" style="right: -1px;">
          <RightOutlined />
        </div>
      </template>
      <div
        class="img-container v-img-container"
        v-for="imgSrc in getPreviewImgs()"
        :key="imgSrc"
      >
        <img
          @load="calculateImg"
          @click="onImgClick"
          v-if="imgSrc"
          alt="pic"
          :src="imgSrc"
        />
        <div v-else class="no-img">{{ $t('common.no_img') }}</div>
      </div>
    </a-carousel>

    <div class="item-info j-content">
      <div class="model-num j-might-overflow">
        {{ vehicle.modelNum }}
      </div>

      <div class="name j-might-overflow">
        {{ $t(vehicle.vehicleName) }}
      </div>
    </div>

    <div class="item-action">
      <a-button
        class="j-outline-btn1 j-height-auto"
        @click="handleSpecification"
        >{{ $t('vehicle.specification') }}</a-button
      >
      <a-button class="j-outline-btn1 j-height-auto" @click="handleAddToCart">{{
        $t('vehicle.addToCart')
      }}</a-button>
    </div>

    <PreviewImageModal
      @after-close="handleAfterClose"
      v-if="showPreviewModal"
      :images="getPreviewImgs()"
    />

    <PreviewImageModal
      @after-close="handleAfterClose"
      v-if="showSpecModal"
      :images="getAttrImage()"
      :isAttributeImg="true"
    />

    <!-- <VehicleSpecModal
      :image="getAttrImage()"
      @after-close="handleAfterClose"
      v-if="showSpecModal"
    /> -->

    <AddToCartModal
      :vehicle="vehicle"
      @after-close="handleAfterClose"
      v-if="showAddToCartModal"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import { baseFileUrl } from '@/utils/constants';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
// import VehicleSpecModal from './VehicleSpecModal.vue';
import AddToCartModal from './AddToCartModal.vue';

export default defineComponent({
  name: 'VehicleItem',
  components: {
    LeftOutlined,
    RightOutlined,
    PreviewImageModal,
    // VehicleSpecModal,
    AddToCartModal
  },
  data() {
    return {
      showPreviewModal: false,
      showSpecModal: false,
      showAddToCartModal: false
    };
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.v-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    getPreviewImgs() {
      const images: string[] = (this.vehicle.showImg || '')
        .split(',')
        .filter(s => s);

      return images.length > 0 ? images.map(i => `${baseFileUrl}${i}`) : [''];
    },
    onImgClick() {
      this.showPreviewModal = true;
    },
    getAttrImage() {
      return this.vehicle.attributeImg
        ? [`${baseFileUrl}${this.vehicle.attributeImg}`]
        : [''];
    },
    handleAfterClose() {
      this.showSpecModal = false;
      this.showPreviewModal = false;
      this.showAddToCartModal = false;
    },
    handleSpecification() {
      this.showSpecModal = true;
    },
    handleAddToCart() {
      this.showAddToCartModal = true;
    }
  }
});
</script>

<style lang="scss" scoped>
.item-container {
  border-radius: 1px;
  border: 1px solid $secondary-color2;

  &:hover {
    border: 1px solid $primary-color;
    transition: border 0.5s;
  }

  .img-container {
    cursor: pointer;
    display: block !important;

    img {
      display: inline-block;
      width: 100%;
      height: 100%;
    }

    .no-img {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .item-info {
    background-color: $secondary-color1;
    padding: 14.5px 20px;
    display: flex;
    align-items: center;

    .model-num {
      font-weight: bold;
      margin-right: 20px;
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: $content-fontsize;
    }

    .name {
      flex: 1;
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #666;
      font-size: 14px;
    }
  }

  .item-action {
    padding: 20px;
    display: flex;
    align-items: center;

    &::v-deep(.ant-btn) {
      flex: 1;
      &:first-child {
        margin-right: 20px;
      }
    }
  }
}

.ant-carousel ::v-deep(.slick-slide) {
  overflow: hidden;
}

.ant-carousel ::v-deep(.custom-slick-arrow:before) {
  display: none;
}

.ant-carousel ::v-deep(.slick-arrow.custom-slick-arrow) {
  width: 30px;
  height: 40px;
  color: #fff;
  font-size: 25px;
  background-color: $primary-color;
  display: flex !important;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: $primary-hover-color;
  }
}
</style>
